export default __webpack_public_path__ + "static/media/nov2023-2.98e2dc42.jpg";